import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Forum from '../views/Forum.vue'
import ForumDetail from '../views/ForumDetail.vue'
import ForumPost from '../views/ForumPost.vue'
import Match from '../views/Match.vue'
import Rank from '../views/Rank.vue'
import UserCenter from '../views/UserCenter.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import GameBuddyApply from '../views/GameBuddyApply.vue'
import GameBuddyTimeSlot from '../views/GameBuddyTimeSlot.vue'
import GameBuddyList from '../views/GameBuddyList.vue'
import GameBuddyBooking from '../views/GameBuddyBooking.vue'
import AdminGameBuddyManager from '../views/AdminGameBuddyManager.vue'
import AdminBookingManager from '../views/AdminBookingManager.vue'
import AdminUserManager from '../views/AdminUserManager.vue'
import Replay from '../views/Replay.vue'
import Broadcast from '../views/Broadcast.vue'
import RandomGroup from '../views/RandomGroup.vue'
import AdminSystemSettings from '../views/AdminSystemSettings.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/forum',
    name: 'Forum',
    component: Forum
  },
  {
    path: '/forum/detail/:id',
    name: 'ForumDetail',
    component: ForumDetail
  },
  {
    path: '/forum/post',
    name: 'ForumPost',
    component: ForumPost
  },
  {
    path: '/forum/post/:id',
    name: 'ForumEdit',
    component: ForumPost
  },
  {
    path: '/match',
    name: 'Match',
    component: Match
  },
  {
    path: '/rank',
    name: 'Rank',
    component: Rank
  },
  {
    path: '/user',
    name: 'UserCenter',
    component: UserCenter
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/game-buddy/apply',
    name: 'GameBuddyApply',
    component: GameBuddyApply
  },
  {
    path: '/game-buddy/time-slot',
    name: 'GameBuddyTimeSlot',
    component: GameBuddyTimeSlot
  },
  {
    path: '/game-buddy-list',
    name: 'GameBuddyList',
    component: GameBuddyList
  },
  { 
    path: '/game-buddy-booking',
    name: 'GameBuddyBooking',
    component: GameBuddyBooking
  },
  { 
    path: '/random-group',
    name: 'RandomGroup',
    component: RandomGroup
  },
  { 
    path: '/replay',
    name: 'Replay',
    component: Replay
  },
  { 
    path: '/broadcast',
    name: 'Broadcast',
    component: Broadcast
  },
  {
    path: '/admin/game-buddy-manager',
    name: 'AdminGameBuddyManager',
    component: AdminGameBuddyManager
  },
  {
    path: '/admin/booking-manager',
    name: 'AdminBookingManager',
    component: AdminBookingManager
  },
  {
    path: '/admin/user-manager',
    name: 'AdminUserManager',
    component: AdminUserManager
  },
  {
    path: '/admin/system-settings',
    name: 'AdminSystemSettings',
    component: AdminSystemSettings
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  // 不需要登录的页面
  const whiteList = ['/login', '/register', '/', '/forum', '/forum/detail', '/forum/post', '/game-buddy-list', '/random-group', '/replay', '/broadcast']
  // 检查是否在白名单中，支持动态路由
  const isInWhiteList = whiteList.some(path => {
    if (path.endsWith('/')) {
      return to.path === path
    }
    return to.path === path || to.path.startsWith(path + '/')
  })
  if (isInWhiteList) {
    next()
  } else {
    if (token) {
      // 检查是否为管理员页面
      if (to.path.startsWith('/admin/')) {
        // 从localStorage获取用户信息，检查角色ID
        const userInfo = localStorage.getItem('user')
        if (userInfo) {
          try {
            const user = JSON.parse(userInfo)
            // 允许admin用户和角色ID为1或0的用户访问管理员页面
            if (user.username === 'admin' || user.roleId === 1 || user.roleId === 0) {
              next()
              return
            }
          } catch (e) {
            console.error('Parse user info error:', e)
          }
        }
        // 从store获取用户名作为备选方案
        const username = localStorage.getItem('username')
        if (username === 'admin') {
          next()
        } else {
          next('/')
        }
      } else {
        next()
      }
    } else {
      next('/login')
    }
  }
})

export default router